import { t } from "i18next";

export const validationTime = 5000;
export const validateRevertTime = 50;

export const validateOnSubmit = (formData, validationRules) => {
    let errors = {};
  
    for (let fieldName in validationRules) {
      const rules = validationRules[fieldName];
      const message = rules['message'];
      for (let rule in rules) {
        switch (rule) {
            case 'required':
                if (!formData[fieldName]) {
                    errors[fieldName] = message?.[rule] || message;
                }
                break;
            case 'minLength':
                if (formData[fieldName] && formData[fieldName].length < rules[rule]) {
                errors[fieldName] = message?.[rule] || message;
                }
                break;
            case 'maxLength':
                if (formData[fieldName] && formData[fieldName].length > rules[rule]) {
                    errors[fieldName] = message?.[rule] || message;
                }
                break;
            case 'minValue':
                if (formData[fieldName] && formData[fieldName] < rules[rule]) {
                    errors[fieldName] = message?.[rule] || message;
                }
                break;
            case 'maxValue':
                if (formData[fieldName] && formData[fieldName] > rules[rule]) {
                    errors[fieldName] = message?.[rule] || message;
                }
                break;
            case 'pattern':
                const regex = new RegExp(rules[rule]);
                if (formData[fieldName] && !regex.test(formData[fieldName])) {
                    errors[fieldName] = message?.[rule] || message;
                }
                break;
            case 'unique':
                const fieldValue = formData[fieldName];
                const uniqueField = Object.keys(formData).find(
                    (key) => key !== fieldName && formData[key] === fieldValue
                );
                if (uniqueField) {
                    errors[fieldName] = message?.[rule] || message;
                }
                break;
            default:
                if (rule === 'custom') {
                    const customValidationFn = rules[rule];
                    const customValidationResult = customValidationFn(formData[fieldName]);
                    if (customValidationResult !== true) {
                        errors[fieldName] = customValidationResult;
                    }
                }
                break;
        }
      }
    }
  
    return errors;
};

export const validateOnFlow = (name, value, validationRules) => {
    let errors = {};
    const rules = validationRules[name];
    const message = rules['message'];
    for (let rule in rules) {
        switch (rule) {
            case 'message' : break;
            case 'required':
                if (!value) {
                errors[name] = message?.[rule] || message;
                }
                break;
            case 'minLength':
                if (value !== null && value.length < rules[rule]) {
                errors[name] = message?.[rule]?.replace('{0}',rules[rule]) || message;
                }
                break;
            case 'maxLength':
                // console.log("value:", value, typeof value);
                if (value !== null && value.length > rules[rule]) {
                    errors[name] = message?.[rule]?.replace('{0}',rules[rule]+1) || message ;
                }
                break;
            case 'minValue':
                
                if (value !== null && value < rules[rule]) {
                    errors[name] = message?.[rule]?.replace('{0}',rules[rule]) || message ;
                }
                break;
            case 'maxValue':
                if (value !== null && value > rules[rule]) {
                    errors[name] = message?.[rule] || message;
                }
                break;
            case 'pattern':
                const regex = new RegExp(rules[rule]);
                if (value && !regex.test(value)) {
                    errors[name] = message?.[rule] || message;
                }
                break;
            case 'custom':
                const customValidationFn = rules[rule];
                const customValidationResult = customValidationFn(value);
                if (customValidationResult) {
                    errors[name] = message?.[rule] || message || customValidationResult;
                }
                break;
            default :
                const customValidationFnc = rules[rule];
                const customValidationRes = customValidationFnc(value);
                if (customValidationRes) {
                    errors[name] = message?.[rule] || message || customValidationRes;
                }
                break;

        }
    }

    return errors;
}


export const genericRules = {
    noSlashRule :{
        custom: (value) => value.includes("/"),
        message: t('BOX_RECORD_NAME_INVALID')
    },
    noSlashRuleObjectJSON :{
        custom: (value) => value.includes("/"),
        message: t('BOX_OBJECT_NAME_INVALID')
    },
    numericRule :{
        minLength: 1,
        maxLength: 9,
        pattern: /^[0-9]+$/,
        minValue: 0,
        // maxValue: 100,
        message: {
            minValue: t('VALIDATE_NUMBER_CANNOT_LESS_0'),
            minLength: t('VALIDATE_ATLEAST_NUMERIC'),
            maxLength: t('VALIDATE_LESS_THAN_NUMERIC'),
            pattern: t('VALIDATE_ONLY_NUMERIC_ALLOWED')
        }
    },
    // No Min Limit for numeric field
    numericRuleWithEmpty :{
        maxLength: 9,
        pattern: /^[0-9]+$/,
        message: {
            minLength: t('VALIDATE_ATLEAST_NUMERIC'),
            maxLength: t('VALIDATE_LESS_THAN_NUMERIC'),
            pattern: t('VALIDATE_ONLY_NUMERIC_ALLOWED')
        }
    },
    // No Max Limit for numeric field
    numericRuleWithNoLengthLimit :{
        minLength: 1,
        pattern: /^[0-9]+$/,
        message: {
            minLength: t('VALIDATE_ATLEAST_NUMERIC'),
            maxLength: t('VALIDATE_LESS_THAN_NUMERIC'),
            pattern: t('VALIDATE_ONLY_NUMERIC_ALLOWED')
        }
    },
    decimal: {
        minLength: 1,
        maxLength: 9,
        pattern: /^[0-9.]+$/,
        custom: multipleDotChecker,
        message: {
            minLength: t('VALIDATE_ATLEAST_NUMERIC'),
            maxLength: t('VALIDATE_LESS_THAN_NUMERIC'),
            pattern: t('VALIDATE_ONLY_NUMERIC_ALLOWED'),
            custom: t('VALIDATE_SINGLE_DECIMAL_DOT')
        }
    }, 
    checkMaxLowerLimit: {
        custom: ([min, max]) => min >= max,
        message: t('VALIDATE_MAX_SHOULD_GREATER_THAN_MIN')
    },
    alphaNumericForXML :{
        spaceInclude: (value) => value?.length && value?.includes(" "),
        firstNonNumeric: (val) => (!(/^[A-Za-z]+$/).test(val[0])),
        onlyAllowedSpecialCharacter: (val) => val?.length && !/^[-a-zA-Z0-9._:\b]+$/.test(val),
    }
}




// Supporting Funcitons
function multipleDotChecker (string) {
    const count = string.match(/\./g)?.length;
    return count > 1;
}


export function keepOneDotAndNumbers(string) {
    let pattern = /[^0-9.]/g;
    let firstTime = false;
    const filteredString = string.replaceAll(pattern,'')?.split('.') || [];
    
    if(filteredString?.length <= 2){
        return filteredString.join('.').substring(0,9);
    }
    
    let cleanString = filteredString.map(ele=>{
        if(!firstTime) {
            firstTime = true;
            return ele+'.';
        }
        return ele; 
    }).join('');
    return cleanString.substring(0,9);
}

export const isInValidInput = (inputValue) => {
    const invalidCharsRegex = /[:*?<>|"\\/\s]+/g;
    if (invalidCharsRegex.test(inputValue)) {
        return { inValid: true, message: t('BOX_INVALID_CHARACTER_FOR_FILE_NAME_CONVERTED_TO_UNDERSCORE') };
    } 
    return { inValid: false, message: '' };
}

export const sanitizeInput = (inputValue) => {
    const invalidCharsRegex = /[:*?<>|"\\/\s]+/g;
    // Replace invalid characters with '_'
    const sanitizedValue = inputValue.replace(invalidCharsRegex, (match) => '_'.repeat(match.length));
    return sanitizedValue;
};

export const validateHexByteSequence = (value) => {
    // Allow empty string (use default replacement)
    if (!value || value.trim() === "") return true;
    // Accepts comma-separated two-digit hex values, e.g. "1A,2B,FF"
    const hexBytePattern = /^([0-9A-Fa-f]{2})(,([0-9A-Fa-f]{2}))*$/;
    if (!hexBytePattern.test(value.trim())) {
        return t('BOX_REPLACE_SINGLE_BYTE_INVALID'); 
    }
    return true;
};

// XML Element Name Validation Functions 

/**
 * Validates XML element name for valid characters
 * Valid: Letters, digits, underscore, hyphen, period, and one colon for namespaces
*/
export const validateXMLElementName = (elementName) => {
    if (!elementName || typeof elementName !== 'string') return false;
    
    let colonFound = false;
    for (let i = 0; i < elementName.length; i++) {
        const char = elementName.charAt(i);
        const isLetter = /[a-zA-Z]/.test(char);
        const isDigit = /[0-9]/.test(char);
        const isValidSpecial = ['_', '-', '.'].includes(char);
        
        if (!isLetter && !isDigit && !isValidSpecial) {
            if (!colonFound && char === ':') {
                colonFound = true;
                continue;
            } else {
                return false;
            }
        }
    }
    return true;
};

/**
 * Fixes XML element name by replacing invalid characters with underscores
*/
export const fixXMLElementName = (elementName) => {
    if (!elementName || typeof elementName !== 'string') return '';
    
    let colonFound = false;
    let result = elementName.trim();
    
    for (let i = 0; i < result.length; i++) {
        const char = result.charAt(i);
        const isLetter = /[a-zA-Z]/.test(char);
        const isDigit = /[0-9]/.test(char);
        const isValidSpecial = ['_', '-', '.'].includes(char);
        
        if (!isLetter && !isDigit && !isValidSpecial) {
            if (!colonFound && char === ':') {
                colonFound = true;
                continue;
            } else {
                result = result.substring(0, i) + '_' + result.substring(i + 1);
            }
        }
    }
    return result;
};

/**
 * Removes leading non-letters from element name
 * XML element names must start with a letter
 */
export const removeLeadingNonLetters = (elementName) => {
    if (!elementName || typeof elementName !== 'string') return '';
    
    const trimmed = elementName.trim();
    let startIndex = 0;
    
    for (let i = 0; i < trimmed.length; i++) {
        const char = trimmed.charAt(i);
        if (/[a-zA-Z]/.test(char)) {
            startIndex = i;
            break;
        }
        if (i === trimmed.length - 1) {
            return ''; // No letters found
        }
    }
    
    return trimmed.substring(startIndex);
};

/**
 * Comprehensive element name validation and auto-correction
 * Combines all validation rules 
 */
export const validateAndFixElementName = (elementName) => {
    if (!elementName || typeof elementName !== 'string') {
        return {
            isValid: false,
            correctedName: '',
            errors: []
        };
    }

    let correctedName = elementName.trim();
    const errors = [];
    let isValid = true;


    // 1. Check first character must be letter
    const firstChar = correctedName.charAt(0);
    if (!/[a-zA-Z]/.test(firstChar)) {
        errors.push(t('BOX_ELEM_NAMES_MUST_START_WITH_LETTER__MODIFY_ELEM_NM'));
        correctedName = removeLeadingNonLetters(correctedName);
        isValid = false;
        
        if (correctedName.length === 0) {
            return {
                isValid: false,
                correctedName: '',
                errors
            };
        }
    }

    // 2. Check for spaces and replace with underscores
    if (correctedName.includes(' ')) {
        errors.push(t('BOX_ELEM_NAMES_CANNOT_HAVE_SPACE__CONSIDER_USING_UNDERSCORE'));
        correctedName = correctedName.replace(/ /g, '_');
        isValid = false;
    }

    // 3. Check for other invalid XML characters
    if (!validateXMLElementName(correctedName)) {
        errors.push(t('BOX_ELEM_NAMES_CANNOT_HAVE_SPECIAL_CHARS'));
        correctedName = fixXMLElementName(correctedName);
        isValid = false;
    }

    return {
        isValid,
        correctedName,
        errors
    };
};

/**
 * Element name validation rules for use with validateOnFlow
 * Includes all validation rules 
 */
export const elementNameValidationRules = {
    ELEMENT_NAME: {
        custom: (value) => {
            if (!value) return null; // Allow empty for optional fields
            
            const validation = validateAndFixElementName(value);
            if (!validation.isValid) {
                return validation.errors[0]; // Return first error
            }
            return null;
        },
        message: {
            custom: t('BOX_ELEM_NAMES_INVALID')
        }
    }
};
